import { z } from "zod";
import { ZDateish } from "./commonSchema";
const emptyStringToUndefined = (value) => {
    if (typeof value !== "string") {
        return value;
    }
    const trimmed = value.trim();
    return trimmed.length === 0 ? undefined : trimmed;
};
const ZOptionalString = z.preprocess(emptyStringToUndefined, z.string().optional());
export const ZMaconomyEmployee = z.object({
    employeeNumber: z.string().min(1),
    initials: z.string().trim().min(1),
    name: z.string().min(1),
    firstName: ZOptionalString,
    middleName: ZOptionalString,
    lastName: ZOptionalString,
    email: ZOptionalString,
    mobilePhone: ZOptionalString,
    postalDistrict: ZOptionalString,
    dateEmployed: ZDateish.nullable().optional(),
    dateEndEmployment: ZDateish.nullable().optional(),
    changedDate: ZDateish.nullable().optional(),
    transactionTimestamp: ZDateish.optional(),
});
